import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";

const LINKS = [
  { href: "#dati", label: "Dati & SOA" },
  { href: "#progetti", label: "Archivio Opere" },
  { href: "#specializzazioni", label: "Specializzazioni" },
  { href: "#registro", label: "Protocollo Esecutivo" },
];

export const TechNavbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="main-navbar"
      className={`sticky top-0 z-50 bg-white/95 backdrop-blur border-b border-slate-200 ${
        scrolled ? "shadow-sm" : ""
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 py-3 flex items-center justify-between">
        <a href="#top" data-testid="nav-logo-link" className="flex items-center">
          <img src="/assets/logo.png" alt="Saircos - General Contractor Edile" className="h-14 w-auto" />
        </a>
        <nav className="hidden md:flex items-center gap-7 text-xs font-semibold tracking-wider uppercase text-slate-600" data-testid="nav-links">
          {LINKS.map((l) => (
            <a key={l.href} href={l.href} data-testid={`nav-link-${l.href.slice(1)}`} className="hover:text-blue-600 transition-colors">
              {l.label}
            </a>
          ))}
        </nav>
        <a
          href="#contact"
          data-testid="nav-cta-button"
          className="hidden md:inline-block px-5 py-2.5 bg-blue-600 hover:bg-blue-700 text-white font-bold text-xs uppercase tracking-wider transition-colors"
        >
          Invia Capitolato
        </a>
        <button data-testid="nav-mobile-toggle" className="md:hidden p-2 text-slate-800" onClick={() => setOpen(!open)} aria-label="Menu">
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>
      {open && (
        <div className="md:hidden bg-white border-t border-slate-200 px-6 py-4 flex flex-col gap-3" data-testid="nav-mobile-menu">
          {LINKS.map((l) => (
            <a key={l.href} href={l.href} onClick={() => setOpen(false)} className="text-xs font-semibold uppercase tracking-wider text-slate-600">
              {l.label}
            </a>
          ))}
          <a href="#contact" onClick={() => setOpen(false)} data-testid="nav-mobile-cta" className="inline-block text-center px-5 py-2.5 bg-blue-600 text-white font-bold text-xs uppercase tracking-wider">
            Invia Capitolato
          </a>
        </div>
      )}
    </header>
  );
};
